import { render, staticRenderFns } from "./AdShopFulfillment.vue?vue&type=template&id=31be80ae&scoped=true&"
import script from "./AdShopFulfillment.vue?vue&type=script&lang=js&"
export * from "./AdShopFulfillment.vue?vue&type=script&lang=js&"
import style0 from "./AdShopFulfillment.vue?vue&type=style&index=0&id=31be80ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31be80ae",
  null
  
)

export default component.exports